import { createReducer } from "reduxsauce";

import ReducerRegister from "../../../ReducerRegister";
import EditService from "../../../../services/screens/admin/exam/EditService";
import { ActionTypes } from "../../../actionTypes/screens/admin/exam/EditActionTypes";
import AsyncActionReducers from "../../../AsyncActionReducers";

import UIDs from "../../../../UIDs";

const uid = UIDs.screens.admin.exam.edit;

//
// Actions
//
const Actions = {
    loadScreenViewAsync: id => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.LOAD_SCREEN_VIEW_ASYNC, id });

            EditService.loadScreenView(
                id,
                response => {
                    dispatch(Actions.loadScreenViewSuccess(response));
                },
                error => {
                    dispatch(Actions.loadScreenViewFailure(error));
                }
            );
        };
    },

    loadScreenViewSuccess: data => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_SUCCESS,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        postReducer: loadScreenViewSuccessPostReducer,
        data
    }),

    loadScreenViewFailure: error => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_FAILURE,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        error
    }),

    saveExamAsync: vo => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.SAVE_EXAM_ASYNC, vo });

            EditService.saveExam(
                vo,
                response => {
                    dispatch(Actions.saveExamSuccess(response));
                },
                error => {
                    dispatch(Actions.saveExamFailure(error));
                }
            );
        };
    },

    saveExamSuccess: data => ({
        type: ActionTypes.SAVE_EXAM_SUCCESS,
        parentType: ActionTypes.SAVE_EXAM_ASYNC,
        data
    }),

    saveExamFailure: error => ({
        type: ActionTypes.SAVE_EXAM_FAILURE,
        parentType: ActionTypes.SAVE_EXAM_ASYNC,
        error
    }),

    createExam: courseId => ({
        type: ActionTypes.CREATE_EXAM,
        courseId
    })
};

//
// Initial State
//
const INITIAL_STATE = {
    exam: null
};

//
// Reducers
//
const loadScreenViewSuccessPostReducer = (state, { data }) => {
    return { ...state, exam: data.exam };
};

const createExamReducer = (state, { courseId }) => {
    return { ...state, exam: { courseId } };
};


// Use reduxsauce's createReducer to make it clearer for
// each action handler
const mergedReducer = createReducer(INITIAL_STATE, {
    [ActionTypes.LOAD_SCREEN_VIEW_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.SAVE_EXAM_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.SAVE_EXAM_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.SAVE_EXAM_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.CREATE_EXAM]: createExamReducer
});

// Enable dynamically register and unregister reducer
const reducer = new ReducerRegister(uid, mergedReducer);

export { ActionTypes, Actions, reducer, INITIAL_STATE };
